<template>
  <div class="echarts">
    <!-- <highcharts id="chart1" :options="options" ></highcharts> -->
    <div id="chart1" ref="chart1"></div>
  </div>
</template>

<script>
import Highcharts from 'highcharts'
export default {
  name: 'salecount',
  props: ['range', 'result', 'colors'],
  data () {
    return {
      options: null,
      chart: null
    }
  },
  watch: {
    result () {
      this.updateData()
    }
  },
  mounted () {
    const params = {
      chart: {
        type: 'pie',
        // backgroundColor: 'var(--color-infobox)',
        backgroundColor: '#FFFFFF',
        plotBackgroundColor: '#FFFFFF',
        height: 386,
        margin: [20, 10, 10, 10],
        spacing: 5
      },
      title: {
        text: '',
        // text: `前10熱門餐點 ${this.range.start.substr(2)} ~ ${this.range.end.substr(2)}`,
        style: {
          letterSpacing: '.5px',
          fontSize: '18px',
          fontWeight: 'normal',
          textAlign: 'right',
          color: '#292929',
          padding: '16px'
        }
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.y}次'
          }
        }
      },
      tooltip: {
        pointFormat: '<b>{point.y}次</b> {point.percentage:.1f}%'
      },
      series: [{
        size: '200px',
        name: '數量',
        data: this.result.map(e => {
          return {
            name: e.name,
            y: e.count
          }
        })
      }]
    }
    if (this.colors) {
      params.colors = this.colors
    }
    this.chart = Highcharts.chart(this.$refs.chart1, params)
  },
  methods: {
    updateData () {
      this.chart.update({
        title: { text: '' },
        // title: { text: `前10熱門餐點 ${this.range.start.substr(2)} ~ ${this.range.end.substr(2)}` },
        series: [{
          size: '200px',
          name: '次數',
          data: this.result.map(e => {
            return {
              name: e.name,
              y: e.count
            }
          })
        }]
      })
    }
  }
}
</script>

<style scoped>
#chart1 {
  /* background-color: #E5E5E5; */
  width: 100%;
  height: 100%;
  /* border: 1px solid var(--color-border); */
}
.echarts {
  width: 476px;
  height: fill;
}
</style>
